/**
 * Represents a single license log entry returned by the admin view API.
 * Field names depend on the backend response.
 */
export type ILicenseLogEntry = Record<string, string | number | boolean | null>;

export type ITableDataResponse = {
  tableName: string;
  rows: ILicenseLogEntry[];
};

export type IAnalysisFrameworkReport = {
  reportMenuItems: Array<{
    id: string;
    reportPage?: {
      name?: string;
      elements?: Array<{
        componentInfo?: {
          columns?: Array<{
            field?: {
              table?: string;
            };
          }>;
        };
      }>;
    };
  }>;
};

export const LicenseLogMeta = {
  path: "/table_data",
  tableName: "licenseLog",
  reportId: "2494",
  bulkInsertApiKey:
    "Me4OgOoc7anWjSCB_uNPRCfpEk8AcJCQAO6CbBuzGuXh0nkK1bTgMDn9IGrPKXFon8ahboAZUGUB3sQC",
  exportApiKey: "mQ7PU_VGfA4OBJAaH8m5eN8jDw6259MgFaJ8TZsPhZhvoFAjIByP7KOzLxc6X5m9V5PClKD5qcixcIEX",
  reportBulkInsertUrl:
    "https://dev.snpkyano.com/api-key-auth-proxy/af/dataset/2494/CustomizedData/BulkInsert",
  reportExportUrl:
    "https://dev.snpkyano.com/api-key-auth-proxy/af/report/2494/Export",
  reportViewerUrl: "https://dev.snpkyano.com/af/#/af/report/v2",
};

export const buildTableDataPayload = (
  tableName: string,
  rows: ILicenseLogEntry[]
): ITableDataResponse => ({
  tableName,
  rows,
});
